// extracted by mini-css-extract-plugin
export default {"title":"field_title__xvNH5","image":"field_image__vDybq","body":"field_body__BNDNl"};